import React from 'react';
import ClientesLatitudSur from '../../img/ClientesLatitudSur.png'
import { Link } from 'react-router-dom';

const ModalClientes = ({modalClientes,setModalClientes}) => {
   
   return (
      <>
         <div className={`modal-home ${modalClientes}`}>
            <div className="modal-clientes-container">
               <img src={ClientesLatitudSur} alt="" className="responsive-img padding-img"/>
               <Link onClick={(e)=>setModalClientes('')} className="btn-flat red text-white">Cerrar</Link>
            </div>
         </div>
      </>
   );
}

export default ModalClientes